import loadingAnimation from '@/assets/animation/generator-loading.json';
import Lottie from 'lottie-react';

// Loading component with animated dots
const Loading = () => {
  return (
    <div className="w-full flex absolute top-[45%] left-[46%]">
      <Lottie animationData={loadingAnimation} loop={true} />
    </div>
  );
};

export default Loading;